import React from "react";

const Footer = () => {
  return (
    <footer>
      <p className="name">
        This project was coded by Patrícia Pereira and is{" "}
        <a
          className="source"
          target="_blank"
          rel="noopener noreferrer"
          href="https://github.com/ppereira2/weather-app"
        >
          open-sourced on GitHub
        </a>
      </p>
    </footer>
  );
};
export default Footer;
